import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure,
} from 'vee-validate';
import { required, email, regex } from 'vee-validate/dist/rules';
import App from './App.vue'
import store from './store';
import router from './router';
import 'bulma/css/bulma.css';
import 'bulma-o-steps/bulma-steps.min.css'
import "./filters.js";

import './assets/css/styles.scss'
import "./assets/css/hamburgers/hamburgers.scss";
import '@fortawesome/fontawesome-free/css/all.css';
import '@creativebulma/bulma-badge/dist/bulma-badge.min.css'

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver)

extend('email', email);
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('regex', regex);

configure({
  classes: {
    valid: 'is-success',
    invalid: 'is-danger',
  }
});

import API from './utils/api';
Vue.prototype.$http = API;

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
